import { ActionButton } from './parts/index.js';
import { useId, useState } from 'react';
import { api } from './api.js';
import './logout.css';

/** End the server session before discarding the signed-in page. */
export function LogoutButton({ corner = false }: { corner?: boolean }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const errorId = useId();
  const logout = async () => {
    if (busy) return;
    setBusy(true); setFailed(false);
    try {
      const response = await api.logout();
      if (!response.ok) throw new Error('Logout failed');
      window.location.replace('/');
    } catch {
      setFailed(true); setBusy(false);
    }
  };
  return <div className={`logout-control${corner ? ' logout-corner' : ''}`}>
    <ActionButton type="button" className="logout-button" title="Log out" aria-label={busy ? 'Logging out' : 'Log out'} aria-busy={busy} aria-describedby={failed ? errorId : undefined} disabled={busy} onClick={() => void logout()}>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 4H5v16h5M9 12h11m-4-4 4 4-4 4" /></svg>
      <span>{busy ? 'Logging out…' : 'Log out'}</span>
    </ActionButton>
    {failed && <p id={errorId} className="logout-error" role="alert">Could not log out. Please try again.</p>}
  </div>;
}
